import { translationAnyText } from '@/legacy/utils/translation';
import SearchItem from '../../SearchItem';
import styles from '../SearchResultPanel.module.scss';
import { SearchResultsListProps } from '../types';
import { useTranslation } from 'react-i18next';
import { TCategory } from '@/legacy/apis/types/searchAPI';
import { ReactNode } from 'react';
import { Icon } from '@/legacy/components/ui-components/Icon';

const icons: Record<TCategory, ReactNode> = {
  Customers: <Icon iconName="customer" />,
  Invoices: <Icon iconName="finance" />,
  Employees: <Icon iconName="employee" />,
  Projects: <Icon iconName="project" />,
  Contacts: <Icon iconName="contact" />,
};

export const SearchResultsList = ({
  searchResult,
  searchValue,
  onItemSelect,
  searchContainerResults,
}: SearchResultsListProps) => {
  const { t } = useTranslation('header');

  return (
    <ul
      data-automation-id="MainSearchResults"
      id="MainSearchResults"
      className={styles.SearchResults}
      ref={searchContainerResults}
    >
      {searchResult?.map(
        ({ isEmpty, category, list }) =>
          !isEmpty && (
            <li
              key={`search-category-${category}`}
              data-automation-id={`SearchCategory${category}`}
            >
              <SearchItem
                searchValue={searchValue}
                searchList={list}
                icon={icons[category]}
                category={category}
                categoryLabel={translationAnyText(
                  t,
                  `SearchCategory${category}Label`,
                )}
                onItemSelect={onItemSelect}
              />
            </li>
          ),
      )}
    </ul>
  );
};
